export default {
  title: "探索 Oracle".toUpperCase(),
}
